import React from 'react'
import { ListGroup, ListGroupItem, Media } from 'reactstrap'
import SFLogo from '../../../images/sf-logo-simple.png'
import AssignDiscountIcon from 'react-icons/lib/fa/plus-square'

const ApplicationSettingPanel = () =>
    <div className="row col-12 justify-content-center align-content-center">
        <h1 className="col-12 font-weight-bold m-3"><Media object src={SFLogo} className="logo-head"/>&nbsp;Application Setting Panel</h1>
        <ListGroup className="col-8 text-left">            
            <ListGroupItem tag="a" href="/management/subsdefaultplan"><AssignDiscountIcon className="offset-md-4"/>&emsp;Default Subscription Plan</ListGroupItem>
            <ListGroupItem tag="a" href="/management/aboutexpiredays"><AssignDiscountIcon className="offset-md-4"/>&emsp;Set About Expire Days</ListGroupItem>
        </ListGroup>
    </div>

export default ApplicationSettingPanel



// WEBPACK FOOTER //
// ./src/components/pages/subscription/ApplicationSettingPanel.js